import { useDispatch, useSelector } from "react-redux";
import { TooltipComponent } from "components/toolTipComponent/TooltipComponent";
import type { TextSize } from "InterfacesTypes/types";
import { setTextSize } from "state/Reducers/TextSizeReducer";

const ORDER: TextSize[] = ["normal", "large", "xLarge"];

interface TextSizeButtonProps {
  tooltipPlacement?: "top" | "right" | "bottom" | "left";
}

export const TextSizeButton = ({ tooltipPlacement= "top" }: TextSizeButtonProps) => {
  const dispatch = useDispatch();

  const textSize = useSelector(
    (state: any) => state.textSize.value
  );

  const handleClick = () => {
    const currentIndex = ORDER.indexOf(textSize);
    const nextIndex = (currentIndex + 1) % ORDER.length;

    dispatch(setTextSize(ORDER[nextIndex]));
  };

  return (
    <>
      <TooltipComponent
        placement={tooltipPlacement}
        content={
          <>
            <div>Ändra textstorlek</div>
            <div>Klicka för att rotera mellan textstorlekarna: normal/större/störst.</div><br />
            <div>Nuvarande textstorlek: <b>{textSize === "normal" ? "Normal" : textSize === "large" ? "Större" : "Störst"}</b></div>
          </>
        }
      >
        <button
          type="button"
          onClick={handleClick}
          className="border-none! w-[50px]! hover:bg-transparent min-w-0!"
        >
          <div className="flex">
            <div className="!text-xs py-[9px]">A</div>
            <div className="!text-base py-[3px]">A</div>
            <div className="!text-lg py-[0px]">A</div>
            <div className="!text-xs">{"(Beta)"}</div>
          </div>
        </button>
      </TooltipComponent>
    </>
  );
};